import { updateDocument } from "db/mutations";
import { getUserId } from "services/auth";
import { COLLECTION_NAME } from ".";

export const removeLogs = async () => {
  const userId = getUserId();

  if (!userId) {
    throw new Error("User not authenticated");
  }

  return updateDocument(COLLECTION_NAME, userId, {
    logs: {},
  }).then(() => ({
    message: "Logs removed successfully",
    success: true,
  }));
};
